// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/scss/style.scss';
import Vue from 'vue';
import { Capacitor } from '@capacitor/core';
import App from './App';
import router from './router';
import i18n from '@/i18n/index';
import store from './store';
import { ApmVuePlugin } from '@elastic/apm-rum-vue';

// Core Plugin
import PrivateAreaCore from '@/plugins/core';
Vue.use(PrivateAreaCore);

// Init App
import { configureApp } from './utils/app/configureApp';
import { configureSafeAreaInsets } from './utils/app/configureSafeAreaInsets';
import { configureSmartBannerInstallApp } from '@/utils/app/configureSmartBannerInstallApp';
import { redirectToApp } from './utils/app/redirectToApp';

import moment from 'moment-timezone';

require('moment/locale/es');
moment.tz.setDefault('Europe/Madrid');

import VueCurrencyInput from 'vue-currency-input';

let reloading = false;

const handleChunkError = () => {
    if (reloading) return;
    reloading = true;

    const lastReload = sessionStorage.getItem('chunk_reload_at');
    const now = Date.now();

    if (!lastReload || now - parseInt(lastReload, 10) > 10000) {
        sessionStorage.setItem('chunk_reload_at', now);
        window.location.replace(window.location.href);
    } else {
        console.warn('Chunk failed after reload, skipping to avoid loop.');
    }
};

const isChunkError = error => {
    const message = error?.message || '';

    return (
        error?.name === 'ChunkLoadError' ||
        /Loading chunk [\d]+ failed/i.test(message) ||
        /Loading CSS chunk failed/i.test(message) ||
        /ChunkLoadError/i.test(message)
    );
};

// IMPORTANTE: antes de Vue init
window.addEventListener(
    'error',
    e => {
        const error = e.error || e;
        if (!isChunkError(error)) return;
        handleChunkError();
    },
    true
);

window.addEventListener('unhandledrejection', event => {
    const error = event.reason;
    if (!isChunkError(error)) return;
    handleChunkError();
});

router.onError(error => {
    if (isChunkError(error)) {
        handleChunkError();
    }
});

const pluginOptions = {
    globalOptions: { currency: null, locale: 'es' }
};
Vue.use(VueCurrencyInput, pluginOptions);

Vue.config.productionTip = false;

let logout = false;

redirectToApp();
configureSafeAreaInsets();
configureApp(logout);

new Vue({
    el: '#app',
    i18n,
    store,
    router,
    components: { App },
    template: '<App/>'
});

if (!Capacitor.isNativePlatform()) {
    configureSmartBannerInstallApp();
}

Vue.use(ApmVuePlugin, {
    router,
    config: {
        serviceName: 'PrivateArea_Frontend',
        environment: process.env.VUE_APP_ENV,
        serverUrl: process.env.VUE_APP_ELASTIC_APM_SERVER_URL,
        secretToken: process.env.VUE_APP_ELASTIC_APM_SECRET_TOKEN,
        active: true
    }
});
